import React, { useState } from "react";
import { Link } from "react-router-dom";
import DonutChart from "../../../../../../component/DonutChart";
import { useSelector, shallowEqual } from "react-redux";
import SelfAttendance from "../table/selfAttendance";

export const AttendanceSummary = ({ attendanceSummary }) => {
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [selectedAttendanceType, setSelectedAttendanceType] = useState("");
  const [selectedAttendanceDetails, setSelectedAttendanceDetails] = useState([]);
  const { attendance } = useSelector(
    (state) => ({
      attendance: state?.auth?.userAccess["Attendance"],
    }),
    shallowEqual
  );

  const isAttRequest = attendance?.find(
    (el) =>
      el?.componentName === "ReadAllAttendanceRequest" && el?.isResourceShow
  );
  const isAttCalendar = attendance?.find(
    (el) => el?.componentName === "ReadAttendanceCalendar" && el?.isResourceShow
  );

  const isHolidayCalendar = attendance?.find(
    (el) => el?.componentName === "MyHolidayCalendar" && el?.isResourceShow
  );

  const attendanceFields = [
    { label: "Present Days", key: "PresentDays" },
    { label: "On Time", key: "OnTime" },
    { label: "Absent Days", key: "AbsentDays" },
    { label: "Late In", key: "LateComing" },
    { label: "Holidays", key: "Holidays" },
    { label: "Early Out", key: "EarlyGoing" },
    { label: "Off Days", key: "OffDay" },
    { label: "Half Days", key: "HalfDay" },
    { label: "Leave Days", key: "LeaveDays" },
  ];
  return (
    <div className="w-full bg-white rounded-lg">
      <div className="w-full text-xs px-3 py-2  flex flex-col h-full justify-between">
        <div className="w-full">
          <h6 className="font-bold mb-0 text-primary my-2">Attendance</h6>
          {/* <DonutChart
            data={
              attendanceSummary && Object.keys(attendanceSummary).length > 0
                ? Object.entries(attendanceSummary)
                    .filter(([key]) => key !== "Id" && key !== "FirstName")
                    .map(([key, value]) => ({
                      label: key,
                      value: value,
                    }))
                : []
            }
          /> */}
          <DonutChart
            data={
              attendanceSummary && Object.keys(attendanceSummary).length > 0
                ? Object.entries(attendanceSummary)
                  .filter(
                    ([key]) =>
                      key !== "Id" &&
                      key !== "FirstName" &&
                      key !== "AttendanceDetails"
                  )
                  .map(([key, value]) => ({
                    label: key,
                    value: value,
                  }))
                : []
            }
            onItemClick={(item) => {
              console.log("DONUT CLICKED:", item);

              const details = attendanceSummary?.AttendanceDetails || [];

              let filteredDetails = [];

              switch (item.label) {
                case "PresentDays":
                  filteredDetails = details.filter(
                    (x) =>
                      x?.isOnTime === 1 ||
                      x?.isLateComing === 1 ||
                      x?.isEarlyGoing === 1 ||
                      x?.isHalfDay === 1
                  );
                  break;

                case "OnTime":
                  filteredDetails = details.filter(
                    (x) => x?.isOnTime === 1
                  );
                  break;

                case "AbsentDays":
                  filteredDetails = details.filter(
                    (x) =>
                      x?.status?.toLowerCase()?.includes("absent")
                  );
                  break;

                case "LateComing":
                  filteredDetails = details.filter(
                    (x) => x?.isLateComing === 1
                  );
                  break;

                case "Holidays":
                  filteredDetails = details.filter(
                    (x) => x?.isHoliday === 1
                  );
                  break;

                case "EarlyGoing":
                  filteredDetails = details.filter(
                    (x) => x?.isEarlyGoing === 1
                  );
                  break;

                case "OffDay":
                  filteredDetails = details.filter(
                    (x) => x?.isOffDay === 1
                  );
                  break;

                case "HalfDay":
                  filteredDetails = details.filter(
                    (x) => x?.isHalfDay === 1
                  );
                  break;

                case "LeaveDays":
                  filteredDetails = details.filter(
                    (x) =>
                      x?.isOnLeave === 1 ||
                      x?.isPartialLeave === 1
                  );
                  break;

                default:
                  filteredDetails = [];
              }

              console.log("FILTERED DETAILS:", filteredDetails);

              setSelectedAttendanceType(item?.label);
              setSelectedAttendanceDetails(filteredDetails);
              setShowAttendanceModal(true);
            }}
          />
        </div>
        <div className="grid grid-cols-2 text-sm gap-x-8 mt-5">
          {attendanceFields.map(({ label, key }) => (
            <div key={key} className="flex justify-between items-center">
              <p className="text-black m-0">{label}</p>
              <p className="text-primary font-extrabold m-0">
                {attendanceSummary?.[key] || 0}
              </p>
            </div>
          ))}
        </div>
        <div className="font-size-xs font-semibold flex gap-4 items-end text-black mt-2 flex-wrap">
          <p className="m-0 underline">
            {isAttRequest ? (
              <Link to="/attendance_request/read-all-attendance-request">
                Attendance Request
              </Link>
            ) : (
              <label className="opacity-50 cursor-not-allowed">
                Attendance Request
              </label>
            )}
          </p>
          <p className="m-0 underline">
            {isAttCalendar ? (
              <Link to="/attendance_calendar_team/read-attendance-calendar">
                Attendance Calendar
              </Link>
            ) : (
              <label className="opacity-50 cursor-not-allowed">
                Attendance Calendar
              </label>
            )}
          </p>
          {/* <p className="m-0 underline">
            {isHolidayCalendar ? (
              <Link to="/holiday_calendar/my-holiday-calendar">
                Holiday Calendar
              </Link>
            ) : (
              <label className="opacity-50 cursor-not-allowed">
                Holiday Calendar
              </label>
            )}
          </p> */}
        </div>
      </div>
      <SelfAttendance
        show={showAttendanceModal}
        onHide={() => {
          setShowAttendanceModal(false);
          setSelectedAttendanceDetails([]);
          setSelectedAttendanceType("");
        }}
        data={selectedAttendanceDetails}
        selectedType={selectedAttendanceType}
      />
    </div>
  );
};
